import { PaymentMethodsButton } from '../PaymentMethodsButton'
import { useMemo } from 'react'
import { mfLogoBaseUrl } from '../../../env'


export const NoBankAccountWithdrawPaymentMethodsButton = ({
  isDisabled,
  handleWithdrawNowClick,
}: {
  isDisabled: boolean
  handleWithdrawNowClick: () => void
  trackingFund?: { fundIsin: string; fundName: string }
}) => {
  const middleTexts = useMemo(() => {
    return [
      { type: 'NORMAL' as const, text: 'Withdrawing to' },
      { type: 'NORMAL_BOLD' as const, text: 'Bank linked to this folio' }
    ]
  }, [])


  return (
    <PaymentMethodsButton
      iconUrl={`${mfLogoBaseUrl}/images/mutual_fund/categories/v2/banking_and_psu.svg`}
      iconClassName='!w-5 !h-5 !ml-2 !mr-1'
      onMiddleTextsClick={() => { }}
      middleTexts={middleTexts}
      onCTAClick={handleWithdrawNowClick}
      ctaLabel='Continue'
      isDisabled={isDisabled}
    />
  )
}
